import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import './ChatHistory.css';
import { UserContext } from '../UserContext';
import AdminNav from '../Navbars/AdminNav';
import Footer from '../Footer';

const ChatHistory = () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userHistory, setUserHistory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { isAdmin, setUserRole, setUserInfo, userInfo } = useContext(UserContext);


    useEffect(() => {
        fetchUsers();
    }, []);

    const fetchUsers = async () => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_LOCAL_SERVER_API}/api/chatbot/users`
            );
            setUsers(response?.data?.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching users:', error);
            setError('Failed to fetch users');
            setLoading(false);
        }
    };

    const fetchUserHistory = async (email) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_LOCAL_SERVER_API}/api/chatbot/userHistory/${email}`
            );
            setUserHistory(response.data?.data);
            setSelectedUser(email);
        } catch (error) {
            console.error('Error fetching user history:', error);
            setError('Failed to fetch user history');
        }
    };

    if (loading) {
        return <div className="chat-history-container">Loading...</div>;
    }

    if (error) {
        return <div className="chat-history-container">Error: {error}</div>;
    }
    const username = userInfo?.username;
    const onLogout = () => {
        fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
            credentials: "include",
            method: "POST",
        })
            .then(() => {
                navigate("/");
            })
            .catch((error) => {
                console.error("Logout failed:", error);
            });
        setUserInfo(null);
        setUserRole("guest");
    };
    return (
        <>
            {username && isAdmin && <AdminNav username={username} onLogout={onLogout} />}
            <div className="chat-history-container">
                <h2>Chat History</h2>

                <div className="chat-history-grid">
                    {/* Users List */}
                    <div className="users-list">
                        <h3>Users</h3>
                        <div className="users-scroll">
                            {users && users?.map((user) => (
                                <div
                                    key={user.email}
                                    className={`user-item ${selectedUser === user.email ? 'selected' : ''}`}
                                    onClick={() => fetchUserHistory(user.email)}
                                >
                                    <div className="user-info">
                                        <strong>{user.name}</strong>
                                        <div>{user.email}</div>
                                        <div>{user.phone}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Chat History */}
                    <div className="history-details">
                        <h3>Chat History {selectedUser && `for ${selectedUser}`}</h3>
                        <div className="history-scroll">
                            {userHistory.length > 0 ? (
                                userHistory?.map((item, index) => (
                                    <div key={index} className="history-item">
                                        <div className="history-timestamp">
                                            {new Date(item.timestamp).toLocaleString()}
                                        </div>
                                        <div className="history-question">
                                            <strong>Question:</strong> {item.question_text}
                                        </div>
                                        <div className="history-answer">
                                            <strong>Answer:</strong> {item.option_text}
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-history">
                                    {selectedUser ? 'No chat history available' : 'Select a user to view chat history'}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ChatHistory; 